import { Box } from "@chakra-ui/layout";
import ModalFormConta from "components/Features/Financeiro/FormConta/ModalFormConta";
import ModalFormPagarConta from "components/Features/Financeiro/FormConta/ModalFormPagarConta";
import { useLoading } from "components/GlobalLoading";
import { useContasInfiniteScroll } from "features/conta/hooks";
import { useEstornarConta } from "features/conta/hooks";
import { useContaStore } from "features/conta/store";
import { showErrorAxios } from "infra/helpers/alerta";
import { useEffect, useState, useMemo, useRef } from "react";
import HeaderConta from "../HeaderConta";
import { ModalContentConta } from "components/ModalContentConta";
import Container from "components/Container";
import DashboardConta from "../DashboardConta";
import { useContentConta } from "../hooks/useContentConta";
import { useDashboardConta } from "features/conta/hooks";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import ModalFiltrosConta from "./components/ModalFiltrosConta/index";
import {
  ContaItemResponse,
  TipoAnexoContaEnum,
} from "core/features/conta/typings";
import ContasCards from "./../TableConta/ContasCards";
import BoletosEmRegistro from "components/BoletosEmRegistro";
import useBoletosEmRegistro from "core/features/conta/hooks/useBoletosEmRegistro";
import { OperacaoEnum } from "resources/enums/conta";
import { ModalLiquidarContas } from "./components/ModalLiquidarContas";
import { useLocation } from "react-router";
import history from "infra/helpers/history";
import ModalHistoricoConta from "components/ModalHistoryConta";
import ModalHistoricoProtesto from "components/ModalHistoricoProtesto";
import ModalAnexosConta from "../../../ModalAnexosConta";

function ContentConta() {
  const cardsListRef = useRef<{ unselectAll: () => any }>(null);
  const { filters, update, reset } = useContaStore();

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const contaId = params.get("id");

  const clearUrl = () => {
    for (const [key] of params.entries()) {
      params.delete(key);
    }
    history.replace({
      search: params.toString(),
    });
  };

  useContentConta();

  const [modalCadastroVisible, setModalCadastroVisible] = useState(false);
  const [historyId, setHistoryId] = useState<string>();
  const [historyIdProtesto, setHistoryIdProtesto] = useState<string>();
  const [modalAnexosData, setModalAnexosData] = useState<{
    contaId: string;
    tipoAnexoId: TipoAnexoContaEnum;
  } | null>(null);

  const [editId, setEditId] = useState<string | undefined>();
  const [detalheId, setDetalheId] = useState<string | undefined>();
  const [pagarContaId, setPagarContaId] = useState<string | undefined>();
  const [isOpenModalFiltros, setIsOpenModalFiltros] = useState(false);
  const { tenant } = useCurrentTenant();
  const [liquidarContasData, setLiquidarContasData] = useState<
    ContaItemResponse[]
  >([]);

  const {
    isLoading,
    data,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isRefetching,
  } = useContasInfiniteScroll({
    ...filters,
    naoConciliado:
      filters.naoConciliado === "1" ? filters.naoConciliado : undefined,
    contaId,
  });

  const { mutate: estornarConta, isLoading: isLoadingEstornarConta } =
    useEstornarConta();

  const { numeroBoletosEmRegistro } = useBoletosEmRegistro(
    filters.operacao === OperacaoEnum.Receita
  );

  const {
    isFetching: isFetchingDashboard,
    data: dataDashboard,
    refetch: refetchDashboard,
  } = useDashboardConta(filters.operacao!, filters);

  useEffect(() => {
    if (editId) {
      setModalCadastroVisible(true);
    }
  }, [editId]);

  useEffect(() => {
    if (!modalCadastroVisible) {
      setEditId(undefined);
    }
  }, [modalCadastroVisible]);

  const resetAll = () => {
    refetch();
    refetchDashboard();
    setModalCadastroVisible(false);
    setPagarContaId(undefined);
    setLiquidarContasData([]);
  };

  const onEstornarConta = async (id: string) => {
    estornarConta(id, {
      onSuccess: () => resetAll(),
      onError: (err: unknown) => showErrorAxios(err),
    });
  };

  useLoading(
    isLoadingEstornarConta || isLoading || (isRefetching && !isFetchingNextPage)
  );

  const contas = useMemo(() => {
    return (
      data?.pages.reduce(
        (agg: ContaItemResponse[], item) => agg.concat(item.items ?? []),
        []
      ) ?? []
    );
  }, [data]);

  return (
    <>
      <Container>
        <HeaderConta onClick={() => setModalCadastroVisible(true)} />

        <Box mt="0px">
          <DashboardConta
            isFetching={isFetchingDashboard}
            data={dataDashboard}
          />

          <Box mt="32px">
            {filters.operacao === OperacaoEnum.Receita ? (
              <BoletosEmRegistro numeroBoletos={numeroBoletosEmRegistro} />
            ) : null}
            <ContasCards
              isLoading={isLoading || isFetchingNextPage}
              fetchNextPage={fetchNextPage}
              hasNextPage={!!hasNextPage}
              setLiquidarContasData={setLiquidarContasData}
              data={contas}
              onEdit={setEditId}
              setIsOpenModalFiltros={setIsOpenModalFiltros}
              onLiquidar={setPagarContaId}
              onEstornar={onEstornarConta}
              onViewHistory={setHistoryId}
              onViewHistoryProtesto={setHistoryIdProtesto}
              onRowClick={(id, ev) => {
                if (
                  ev.target instanceof HTMLDivElement ||
                  ev.target instanceof HTMLSpanElement ||
                  ev.target instanceof SVGSVGElement ||
                  ev.target instanceof HTMLButtonElement
                ) {
                  const target = ev.target.closest("div");

                  if (target?.id.includes("tag-tipo-anexo")) {
                    const tipoAnexoId = target.id.split("anexo-").pop();
                    setModalAnexosData({
                      contaId: id,
                      tipoAnexoId: tipoAnexoId! as TipoAnexoContaEnum,
                    });
                    return;
                  }

                  if (target?.id.includes("tag-menu")) {
                    return;
                  }
                }

                setDetalheId(id);
              }}
              refresh={() => {
                refetch();
                refetchDashboard();
              }}
              ref={cardsListRef}
            />
          </Box>
        </Box>
      </Container>

      {modalCadastroVisible ? (
        <ModalFormConta
          operacao={filters.operacao!}
          id={editId}
          isOpen={modalCadastroVisible}
          onClose={() => {
            setModalCadastroVisible(false);
          }}
          onSuccess={() => {
            refetch();
            refetchDashboard();
            setModalCadastroVisible(false);
          }}
          onSuccessImmediatelyAfterSave={false}
        />
      ) : null}

      {historyId ? (
        <ModalHistoricoConta
          isOpenModal={!!historyId}
          onClose={() => {
            setHistoryId(undefined);
          }}
          contaId={historyId}
        />
      ) : null}

      {historyIdProtesto ? (
        <ModalHistoricoProtesto
          isOpenModal={!!historyIdProtesto}
          onClose={() => {
            setHistoryIdProtesto(undefined);
          }}
          contaId={historyIdProtesto}
        />
      ) : null}

      {modalAnexosData ? (
        <ModalAnexosConta
          isOpenModal={!!modalAnexosData}
          onClose={() => {
            setModalAnexosData(null);
          }}
          contaId={modalAnexosData.contaId}
          tipoAnexoId={modalAnexosData.tipoAnexoId}
          refetch={refetch}
        />
      ) : null}

      {pagarContaId ? (
        <ModalFormPagarConta
          operacao={filters.operacao!}
          contaId={pagarContaId}
          isOpen={!!pagarContaId}
          onClose={() => setPagarContaId(undefined)}
          onSaved={() => {
            refetch();
            refetchDashboard();
            setPagarContaId(undefined);

            if (cardsListRef) {
              cardsListRef?.current?.unselectAll();
            }
          }}
        />
      ) : null}

      {detalheId ? (
        <ModalContentConta
          isOpenModal={!!detalheId}
          onClose={() => setDetalheId(undefined)}
          contaId={detalheId}
          onEdit={setEditId}
          onLiquidar={setPagarContaId}
          refetch={() => {
            refetch();
            refetchDashboard();
          }}
          operacao={filters.operacao!}
        />
      ) : null}

      <ModalFiltrosConta
        update={update}
        tenantId={tenant.id}
        filtro={filters}
        onClose={() => setIsOpenModalFiltros(false)}
        open={isOpenModalFiltros}
        onReset={() => {
          reset();
          clearUrl();
        }}
      />

      {liquidarContasData?.length ? (
        <ModalLiquidarContas
          isOpenModal={!!liquidarContasData.length}
          data={liquidarContasData}
          refetch={() => {
            if (cardsListRef) {
              cardsListRef?.current?.unselectAll();
            }
            refetch();
          }}
          operacao={filters.operacao}
          onClose={() => setLiquidarContasData([])}
        />
      ) : null}
    </>
  );
}

export default ContentConta;
